import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AddEdit from '../components/addEdit/index.vue';

var AddTruckReservationOrderPage = function (_super) {
  __extends(AddTruckReservationOrderPage, _super);

  function AddTruckReservationOrderPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  AddTruckReservationOrderPage = __decorate([Component({
    components: {
      AddEdit: AddEdit
    }
  })], AddTruckReservationOrderPage);
  return AddTruckReservationOrderPage;
}(Vue);

export default AddTruckReservationOrderPage;